import { getAmplitudeInstance } from '../amplitudeHelpers';
import PageType from '../enums/PageType';
import ShowMoreLocation from '../enums/ShowMoreLocation';

type logShowMoreClickedParams = {
  inspirational_list_type?: string;
  page_type?: PageType;
  show_more_location?: ShowMoreLocation;
};

/**
 * User clicks 'show more' to expand a section. This is a generic event started in July 2024, specific Trail Details & Review Filters Show More Clicked events predate this generic event.
 * @param params - Attributes to log with the amplitude event
 * @param params.inspirational_list_type - inspirational list type of the page (programmatic list, sponsored list, trail, etc,), passed from server
 * @param params.page_type - The type of content page on which a “show more” CTA was clicked.
 * @param params.show_more_location - The location of the show more CTA on a page.
 */
const logShowMoreClicked = ({ inspirational_list_type, page_type, show_more_location }: logShowMoreClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'show more clicked',
    { 'inspirational list type': inspirational_list_type, 'page type': page_type, 'show more location': show_more_location },
    callback
  );
};

export default logShowMoreClicked;
